export default function ClientDashboard() {
  return (
    <section className="py-24 bg-gray-900 text-white relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-96 h-96 bg-cyan-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl"></div>
        {/* Code Lines Decoration */}
        <div className="absolute top-40 left-20 text-cyan-400/10 font-mono text-sm">
          &lt;schema type="Organization" /&gt;
        </div>
        <div className="absolute bottom-40 right-20 text-pink-500/10 font-mono text-sm">
          Core Web Vitals: 98/100
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full backdrop-blur-sm">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm font-medium">Acceso 24/7</span>
              </div>
              <h2 className="text-5xl font-bold leading-tight">
                Panel de Acceso
                <br />
                <span className="text-cyan-500">para Clientes</span>
              </h2>
              <p className="text-xl text-gray-300 leading-relaxed">
                Monitoriza la evolución de tu sitio web en tiempo real con nuestro dashboard intuitivo y completo
              </p>
            </div>

            <div className="space-y-4">
              {[
                {
                  icon: 'ri-line-chart-line',
                  title: 'Evolución de Rankings',
                  description: 'Seguimiento diario de posiciones en Google para todas tus keywords'
                },
                {
                  icon: 'ri-speed-line',
                  title: 'Core Web Vitals',
                  description: 'Métricas de rendimiento actualizadas: LCP, FID, CLS en tiempo real'
                },
                {
                  icon: 'ri-notification-3-line',
                  title: 'Alertas Automáticas',
                  description: 'Notificaciones instantáneas de cambios importantes en tu SEO'
                },
                {
                  icon: 'ri-calendar-check-line',
                  title: 'Acciones Programadas',
                  description: 'Calendario de optimizaciones automáticas planificadas'
                }
              ].map((feature, index) => (
                <div key={index} className="flex items-start gap-4 p-4 bg-white/5 rounded-2xl backdrop-blur-sm hover:bg-white/10 transition-all duration-300">
                  <div className="w-12 h-12 rounded-xl bg-cyan-500 flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-1">{feature.title}</h4>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <a href="#contacto" className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-cyan-400/50 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Solicitar información
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Right Content - Dashboard Mockup */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 shadow-2xl">
              {/* Dashboard Header */}
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-2xl font-bold">Dashboard SEO</h3>
                  <p className="text-gray-400 text-sm">Última actualización: hace 2 minutos</p>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-green-500/20 rounded-full">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-green-400 text-sm font-medium">Live</span>
                </div>
              </div>

              {/* Metrics Grid */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-cyan-500/20 rounded-2xl p-4 border border-cyan-400/30">
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-trophy-line text-cyan-400 text-xl"></i>
                    <span className="text-sm text-gray-300">Posición Media</span>
                  </div>
                  <div className="text-3xl font-bold">3.2</div>
                  <div className="flex items-center gap-1 text-green-400 text-sm mt-1">
                    <i className="ri-arrow-up-line"></i>
                    <span>+2.1 esta semana</span>
                  </div>
                </div>

                <div className="bg-purple-500/20 rounded-2xl p-4 border border-purple-400/30">
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-user-line text-purple-400 text-xl"></i>
                    <span className="text-sm text-gray-300">Tráfico Orgánico</span>
                  </div>
                  <div className="text-3xl font-bold">+287%</div>
                  <div className="flex items-center gap-1 text-green-400 text-sm mt-1">
                    <i className="ri-arrow-up-line"></i>
                    <span>vs mes anterior</span>
                  </div>
                </div>

                <div className="bg-green-500/20 rounded-2xl p-4 border border-green-400/30">
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-speed-line text-green-400 text-xl"></i>
                    <span className="text-sm text-gray-300">Core Web Vitals</span>
                  </div>
                  <div className="text-3xl font-bold">98</div>
                  <div className="flex items-center gap-1 text-green-400 text-sm mt-1">
                    <i className="ri-check-line"></i>
                    <span>Excelente</span>
                  </div>
                </div>

                <div className="bg-orange-500/20 rounded-2xl p-4 border border-orange-400/30">
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-links-line text-orange-400 text-xl"></i>
                    <span className="text-sm text-gray-300">Backlinks</span>
                  </div>
                  <div className="text-3xl font-bold">1,247</div>
                  <div className="flex items-center gap-1 text-green-400 text-sm mt-1">
                    <i className="ri-arrow-up-line"></i>
                    <span>+89 este mes</span>
                  </div>
                </div>
              </div>

              {/* Keywords Ranking */}
              <div className="bg-white/5 rounded-2xl p-4 border border-white/10">
                <h4 className="font-bold mb-4 flex items-center gap-2">
                  <i className="ri-key-line text-cyan-400"></i>
                  Top Keywords
                </h4>
                <div className="space-y-3">
                  {[
                    { keyword: 'automatización seo', position: 1, trend: 'up', change: '+2' },
                    { keyword: 'seo con ia', position: 3, trend: 'up', change: '+5' },
                    { keyword: 'optimización web', position: 2, trend: 'up', change: '+1' },
                    { keyword: 'seo técnico', position: 4, trend: 'up', change: '+3' }
                  ].map((item, index) => (
                    <div key={index} className="flex items-center justify-between p-3 bg-white/5 rounded-xl hover:bg-white/10 transition-all duration-300">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-cyan-500 flex items-center justify-center font-bold text-sm">
                          {item.position}
                        </div>
                        <span className="text-sm">{item.keyword}</span>
                      </div>
                      <div className="flex items-center gap-1 text-green-400 text-sm">
                        <i className="ri-arrow-up-line"></i>
                        <span>{item.change}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-cyan-500 rounded-3xl opacity-20 blur-2xl animate-pulse"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-purple-500 rounded-3xl opacity-20 blur-2xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
}
